import styled from 'styled-components'

export const ManyUserUploadFormStyled = styled.div`
  color: ${({ theme }) => theme.COLORS.RED_1};
`
